import { Component, ElementRef, ViewChild } from "@angular/core";
import { TableCheckboxService } from "@shared/services/table-checkbox.service";

@Component({
	selector: "app-table-header-checkbox",
	templateUrl: "./table-header-checkbox.component.html",
	styleUrls: ["./table-header-checkbox.component.scss"],
	standalone: false
})
export class TableHeaderCheckboxComponent {
	constructor(private tableCheckboxService: TableCheckboxService) {}

	@ViewChild("check") check!: ElementRef<HTMLInputElement>;
	checkAllDt$ = this.tableCheckboxService.checkAllDt$;

	checkUncheckAll(event: HTMLInputElement): void {
		this.tableCheckboxService.setStatusCheckAll(event.checked);
	}
}
